'use strict';

var Driver = global.WebSocket || global.MozWebSocket;
if (Driver) {
	module.exports = function WebSocketBrowserDriver(url) {
		return new Driver(url);
	};
}



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/transport/browser/websocket.js
// module id = 30
// module chunks = 0